"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StitchDatabaseBrowser_1 = __importDefault(require("./StitchDatabaseBrowser"));

var StitchDatabaseServer_1 = __importDefault(require("./StitchDatabaseServer"));

var StitchProxy =
/** @class */
function () {
  function StitchProxy(app, db, sdk) {
    this.app = app;
    this.auth = app.auth;
    this.db = db;
    this.sdk = sdk;
  }

  StitchProxy.prototype.createAnonymousCredential = function () {
    return new this.sdk.AnonymousCredential();
  };

  StitchProxy.prototype.createCustomsCredential = function (token) {
    return new this.sdk.CustomCredential(token);
  };

  StitchProxy.init = function (type, clientAppId, dbService, dbName) {
    return new Promise(function (res) {
      if (type == "browser") {
        // tslint:disable-next-line:semicolon
        Promise.resolve().then(function () {
          return __importStar(require("mongodb-stitch-browser-sdk"));
        }).then(function (sdk) {
          var app = sdk.Stitch.initializeDefaultAppClient(clientAppId);
          var dbSvc = app.getServiceClient(sdk.RemoteMongoClient.factory, dbService).db(dbName);
          var db = new StitchDatabaseBrowser_1.default(dbSvc);
          res(new StitchProxy(app, db, sdk)); // tslint:disable-next-line:semicolon
        }).catch(function (err) {
          console.error(err);
        });
      }

      if (type == "server") {
        // tslint:disable-next-line:semicolon
        Promise.resolve().then(function () {
          return __importStar(require("mongodb-stitch-server-sdk"));
        }).then(function (sdk) {
          var app = sdk.Stitch.initializeDefaultAppClient(clientAppId);
          var dbSvc = app.getServiceClient(sdk.RemoteMongoClient.factory, dbService).db(dbName);
          var db = new StitchDatabaseServer_1.default(dbSvc);
          res(new StitchProxy(app, db, sdk)); // tslint:disable-next-line:semicolon
        }).catch(function (err) {
          console.error(err);
        });
      }
    });
  };

  return StitchProxy;
}();

exports.StitchProxy = StitchProxy;